import history from '@history';
import _ from '@lodash';
import { ObjectId } from 'app/common.types';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import { resetNotificationSlice } from 'app/main/apps/communicationCampaign/ducks/notification.slice';
import { resetFranchiseSlice } from 'app/main/apps/franchises/ducks/franchises.slice';
import { actions as loyaltyActions } from 'app/main/apps/loyalties/ducks/loyalty.slice';
import { getOwnerPermissionsApi } from 'app/main/apps/usersManagement/ownersManagement/api';
import { resetClientsSlice } from 'app/main/pages/clients/ducks/clients.slice';
import jwtService from 'app/services/jwtService';
import { RootState } from 'app/store';
import { showMessage } from 'app/store/fuse/messageSlice';
import { setInitialSettings } from 'app/store/fuse/settingsSlice';
import i18n from 'i18n';
import { adminLoggedOut } from './admin.slice';
import { UserState } from './type';
import { setUser, setUserPermissions, userLoggedOut } from './userSlice';

export const updateUserLocally = (userData: Partial<UserState>) => async (dispatch: any, getState: any) => {
  const oldUser = getState().auth.user;
  const user = _.merge({}, oldUser, userData);

  dispatch(setUser(user));
};

export const logoutUser = () => async (dispatch: any, getState: () => RootState) => {
  const { user } = getState().auth;

  if (!user.role || user.role.length === 0) {
    // is guest
    return null;
  }

  history.push({
    pathname: routesUrl.login,
  });

  jwtService.logout();

  dispatch(setInitialSettings());
  dispatch(userLoggedOut());
  dispatch(adminLoggedOut());
  dispatch(resetClientsSlice());
  dispatch(resetFranchiseSlice());
  dispatch(loyaltyActions.resetLoyaltySlice());
  dispatch(resetNotificationSlice());
};

export const getOwnerPermissionsThunk = (franchiseId: ObjectId, userId: ObjectId) => async (dispatch: any) => {
  try {
    const permissions = await getOwnerPermissionsApi(franchiseId, userId);
    dispatch(setUserPermissions(permissions));
  } catch (_error) {
    dispatch(
      showMessage({
        message: i18n.t('pages.franchises.developer.errors.getPermissions'),
        variant: 'error',
      }),
    );
  }
};
